import Axios from "axios";
import KnockOut from "knockout";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class SearchViewModel {
    constructor() {
        let self: any = this;
        let minTextLength: number = 3;

        self.search = KnockOut.observable().extend({ rateLimit: 1000 });
        self.suggestions = KnockOut.observableArray(null);

        self.showSuggestions = KnockOut.computed(function () {
            return checkMinTextLength(self.search()) && self.search() && self.search().length;
        });

        self.showNotFound = KnockOut.computed(function () {
            return checkMinTextLength(self.search()) && self.suggestions() && !self.suggestions().length;
        });

        self.searchList = function () {
            GTagHelper.sendEvent("view_search_results", { search_term: self.search() });
            location.href = (<any>window).App.routes.Search_List + "?search=" + self.search();
        };

        self.clearSearch = function () {
            self.search(null);
            self.suggestions(null);
            $(".menu").removeAttr("data-show");
            $(".search").removeAttr("data-show");
            $(".wrap-tap").fadeOut();
        };

        // Subscriptions
        self.search.subscribe(function (search) {
            if (checkMinTextLength(search)) {
                getSuggestions(search);
            }
        });

        async function getSuggestions(search) {
            self.suggestions(null);

            let suggestions = (await Axios.post((<any>window).App.routes.Search_GetSuggestions, { search: search })).data;
            self.suggestions(suggestions);
            setCarouselSearch();

            $(".ga-event[data-ga-id=\"HeaderSeachDetail\"]").on("click", function () {
                GTagHelper.sendEvent("click", { search_to_detail: $(this).attr("href") });
            });
        }

        function checkMinTextLength(search) {
            return search && search.length >= minTextLength;
        }

        function setCarouselSearch() {
            var btnNextArrow = '<div class="slick-arrow fastic-next" data-type="next"></div>',
                btnPrevArrow = '<div class="slick-arrow fastic-prev" data-type="prev"></div>',
                settings = {
                    lazyLoad: "ondemand",
                    infinite: false,
                    speed: 900,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 4000,
                    variableWidth: false,
                    nextArrow: btnNextArrow,
                    prevArrow: btnPrevArrow,
                    responsive: [
                        {
                            breakpoint: 1010,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 749,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 599,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false
                            }
                        }
                    ]
                };

            (<any>$(".search-carousel.slick-initialized")).slick("removeSlide", null, false, true);
            (<any>$(".search-carousel.slick-initialized")).slick("unslick");
            (<any>$(".search-carousel").not(".slick-initialized")).slick(settings);
        }
    }
}